import { Component } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    imports: [SidebarComponent, RouterOutlet]
})
export class HomeComponent {
  user = {};

  constructor(
    public translate: TranslocoService,
  ) {
    translate.setDefaultLang('ru');
    translate.setActiveLang('ru');
  }
}
